export const useSipUser = (user, password, domain) => {
  let url = `sip:${user}@${domain}`

  return {
    aor: url,
    authorizationPassword: password,
    authorizationUsername: user,
  }
}
